import jwtDecode from 'jwt-decode';
import { useAuthUserStore } from '@lib';
import { JwtToken } from '@shared/api';
import { AuthUser, PermissionLevel, PermissionType, RoleType, UserPartnerAccountManager } from '@shared/types';

const createTokenMemo = () => {
  let accessToken: string;
  let value: JwtToken;

  return (current: string) => {
    if (accessToken !== current) {
      accessToken = current;
      const result = jwtDecode(accessToken) as JwtToken;
      value = result;
    }

    return value;
  };
};
const tokenMemo = createTokenMemo();

export class PermissionsUtils {
  static hasPermission(permission: PermissionType, level: PermissionLevel, role?: RoleType) {
    const key: string = `Permissions.${permission}.${level}`;
    try {
      const authUser = this.getAuthUser();
      if (!!role && !authUser.roles[role]) return false;
      return authUser.permissions[key];
    } catch {
      return false;
    }
  }

  static getToken(): JwtToken {
    const authUser = this.getAuthUser();
    return tokenMemo(authUser.accessToken);
  }

  static hasRole(role: RoleType) {
    try {
      const token = this.getToken();
      return token?.client_Role === role;
      // return authUser.roles[role];
    } catch {
      return false;
    }
  }

  static getAuthUser(): AuthUser {
    const authUser = useAuthUserStore.getState().authUser;
    if (!authUser) throw new Error('User not logged in');
    return authUser;
  }

  static getUserAccountManager(): UserPartnerAccountManager | undefined {
    const authUser = this.getAuthUser();
    const token = tokenMemo(authUser.accessToken);
    if (token)
      return {
        partnerAccountManagerId: token.client_UserId,
        partnerAccountManagerName: token.client_Fullname,
      };
    return undefined;
  }

  static getUserId(): string | undefined {
    const authUser = this.getAuthUser();
    const token = tokenMemo(authUser.accessToken);
    return token?.client_UserId;
  }

  static getUserCicles(): string[] {
    const authUser = this.getAuthUser();
    const token = tokenMemo(authUser.accessToken);
    return token?.client_Groups;
  }
}
